module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "账号 / 姓名 / 企业",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "souch_change souch_input",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "souch_change souch_input",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "部门",
      "clearable": ""
    },
    model: {
      value: (_vm.deptId),
      callback: function($$v) {
        _vm.deptId = $$v
      },
      expression: "deptId"
    }
  }, _vm._l((_vm.detpList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("添加用户")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55",
      "selectable": _vm.selectInit
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invitestatusname",
      "label": "状态",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [(!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.batchRemove(scope.$index, scope.row)
            }
          }
        })]) : _c('span', {
          staticClass: "dnnfont icondelete icon-disabled"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "添加",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs2
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.optionsSouch2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch2),
      expression: "disSouch2"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getComUser(1)
      }
    },
    model: {
      value: (_vm.proName2),
      callback: function($$v) {
        _vm.proName2 = $$v
      },
      expression: "proName2"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSofttype2),
      expression: "disSofttype2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.souchs2.softtype),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "softtype", $$v)
      },
      expression: "souchs2.softtype"
    }
  }, _vm._l((_vm.softtypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime1),
      expression: "disTime1"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "开始日期时间"
    },
    model: {
      value: (_vm.souchs2.fromtime),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "fromtime", $$v)
      },
      expression: "souchs2.fromtime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime2),
      expression: "disTime2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "结束日期时间"
    },
    model: {
      value: (_vm.souchs2.totime),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "totime", $$v)
      },
      expression: "souchs2.totime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getComUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
    return _c('el-tag', {
      key: tag2,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag2)
        }
      }
    }, [_vm._v(" \n              " + _vm._s(tag2) + " \n          ")])
  }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags2
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "companyList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange2,
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "softtype",
      "label": "软件类型",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100, '全部'],
      "page-size": _vm.pageSize2,
      "total": _vm.total2,
      "current-page": _vm.pageNumber2
    },
    on: {
      "current-change": _vm.handleCurrentChange2,
      "size-change": _vm.handleSizeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fe42602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/Companyed.vue
// module id = 1716
// module chunks = 9